import React from 'react';
import Card from './Card';

const SubmissionCard = ({base_url}) => {
  const fields = ['user_id', 'exam_id', 'submission_date', 'result'];
  const endpoint = `${base_url}/submissions`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default SubmissionCard;